import { AboutHero } from "../components/nk/AboutHero";
import { Manifesto } from "../components/nk/Manifesto";
import { Statement } from "../components/nk/Statement";
import { Testimonials } from "../components/nk/Testimonials";
import { CtaBand } from "../components/nk/CtaBand";
import { Seo } from "../components/nk/Seo";

const NANCY_SEWING = "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/8qd2m76r_hf_20260829_073922_fea2995e-6aec-4e83-9f97-7433e879bb73%20%281%29.png";

export default function AboutPage() {
  return (
    <>
      <Seo
        title="About Nancy — Renowned Brisbane Seamstress, Now in Perth | NK Bridal"
        description="Meet Nancy of NK Bridal Australia — a celebrated Brisbane bridal seamstress now creating couture wedding gowns and alterations in Perth, and visiting Brisbane regularly."
        path="/about"
      />
      <AboutHero />
      <Manifesto hideHeading mediaImg={NANCY_SEWING} />
      <Statement />
      <Testimonials />
      <CtaBand />
    </>
  );
}
